import { render, staticRenderFns } from "./MenuBodega.vue?vue&type=template&id=0d873396&scoped=true&"
import script from "./MenuBodega.vue?vue&type=script&lang=js&"
export * from "./MenuBodega.vue?vue&type=script&lang=js&"
import style0 from "./MenuBodega.vue?vue&type=style&index=0&id=0d873396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d873396",
  null
  
)

export default component.exports